import React from 'react';
import { Typography } from 'antd';
import List from './List';

export default function Lectures(): React.ReactNode {
  return (
    <div>
      <Typography.Title level={4}>
        Лекции
      </Typography.Title>
      <List />
    </div>
  );
}
